import {
  Flex,
  theme,
  Typography
} from "antd";



function Card({
  title,
  Icon = null,
  actions,
  children,
  className,
  noHeader,
  paddingClassName,
  style = {},
  ...props
}: {
  title?: string;
  Icon?: React.ComponentType<any> | null;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  noHeader?: boolean;
  paddingClassName?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}) {
  const {
    token: { colorBgContainer, colorText },
  } = theme.useToken();
  return (
    <Flex vertical
      className={`${className || ''} rounded-2xl block border-none w-full ${paddingClassName ?? 'p-4 md:p-6'} `}
      style={{
        backgroundColor: colorBgContainer,
        boxShadow: "var(--shadow-sm)",
        ...style,
      }}
      {...props}
    >
      {!noHeader && <Flex justify="space-between">
        <Flex align="center" gap={8} className="mb-6">
          {Icon && <Icon className="text-[20px] text-gray-500 mb-2" />}
          <Typography.Title className="m-0 p-0 font-extrabold" level={3} style={{
            fontSize: "1.25rem",
            color: colorText
          }}>
            {title}
          </Typography.Title>
        </Flex>
        {
          actions && (
            <Flex>
              {actions}
            </Flex>
          )
        }
      </Flex>}
      {children}
    </Flex>

  )
}

export default Card;